import L from "leaflet";
import { LEAFLET_ICONS } from "../constants/mapConstants";

export const configureLeafletIcons = () => {
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions(LEAFLET_ICONS);
};

// Custom icon creator
export const createSiteIcon = (status) => {
  return L.divIcon({
    className: "custom-div-icon",
    html: `
      <div style="
        background-color: #ffffffff;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid white;
        box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      ">
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 128 128">
          <path fill="#424242" d="M83.05 124h-38.1c-5.26 0-9.53-4.27-9.53-9.53V13.53c0-5.26 4.27-9.53 9.53-9.53h38.11c5.26 0 9.53 4.27 9.53 9.53v100.94c-.01 5.26-4.27 9.53-9.54 9.53z"/>
          <circle cx="64" cy="102.92" r="13.41" fill="#4CAF50"/>
          <path fill="#6FD86F" d="M54.64 104.09c-1.14-.36-1.45-4.36 1.22-7.57c3.98-4.79 9.71-4.67 10.32-2.12c.85 3.57-3.67 2.16-7.11 5.04c-2.15 1.8-2.62 5.22-4.43 4.65z"/>
          <circle cx="64" cy="66.21" r="13.41" fill="#FFCA28"/>
          <path fill="#FFF59D" d="M54.64 67.39c-1.14-.36-1.45-4.36 1.22-7.57c3.98-4.79 9.71-4.67 10.32-2.12c.85 3.57-3.67 2.16-7.11 5.04c-2.15 1.8-2.62 5.22-4.43 4.65z"/>
          <circle cx="64" cy="29.5" r="13.41" fill="#F44336"/>
          <path fill="#FF8155" d="M54.64 30.68c-1.14-.36-1.45-4.36 1.22-7.57c3.98-4.79 9.71-4.67 10.32-2.12c.85 3.57-3.67 2.16-7.11 5.04c-2.15 1.8-2.62 5.22-4.43 4.65z"/>
          <path fill="#757575" d="M49.48 23.12c-.47.92-1.89.88-1.76-.52c.32-3.41 2.26-6.09 3.85-7.73c3.16-3.32 7.8-5.21 12.43-5.2c4.63-.02 9.27 1.88 12.44 5.19c1.59 1.64 3.85 5.3 3.86 7.85c0 1.11-1.26 1.41-1.72.51c-1.15-2.24-4.71-9.55-14.57-9.55c-9.88 0-13.39 7.23-14.53 9.45zm0 73.5c-.47.92-1.89.88-1.76-.52c.32-3.41 2.26-6.09 3.85-7.73c3.16-3.32 7.8-5.21 12.43-5.2c4.63-.02 9.27 1.88 12.44 5.19c1.59 1.64 3.85 5.3 3.86 7.85c0 1.11-1.26 1.41-1.72.51c-1.15-2.24-4.71-9.55-14.57-9.55c-9.88 0-13.39 7.24-14.53 9.45zm0-36.75c-.47.92-1.89.88-1.76-.52c.32-3.41 2.26-6.09 3.85-7.73c3.16-3.32 7.8-5.21 12.43-5.2c4.63-.02 9.27 1.88 12.44 5.19c1.59 1.64 3.85 5.3 3.86 7.85c0 1.11-1.26 1.41-1.72.51c-1.15-2.24-4.71-9.55-14.57-9.55s-13.39 7.23-14.53 9.45z"/>
        </svg>
      </div>
    `,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
  });
};

// Helper: safely compute bounds from GeoJSON features
export const getGeoJsonBounds = (geojson) => {
  if (!geojson || !geojson.features || geojson.features.length === 0)
    return null;

  let minLat = 90, minLon = 180, maxLat = -90, maxLon = -180;

  geojson.features.forEach((feature) => {
    if (!feature.geometry) return;

    const coords = L.GeoJSON.coordsToLatLngs(
      feature.geometry.coordinates,
      feature.geometry.type === "Polygon" ? 1 : 2
    ).flat(Infinity);

    coords.forEach(({ lat, lng }) => {
      if (isFinite(lat) && isFinite(lng)) {
        minLat = Math.min(minLat, lat);
        maxLat = Math.max(maxLat, lat);
        minLon = Math.min(minLon, lng);
        maxLon = Math.max(maxLon, lng);
      }
    });
  });

  if (!isFinite(minLat) || !isFinite(minLon) || !isFinite(maxLat) || !isFinite(maxLon)) {
    return null;
  }

  return { minlat: minLat, minlon: minLon, maxlat: maxLat, maxlon: maxLon };
};

// Safe fitBounds helper
export const createSafeFitBounds = (mapInstance) => (bounds) => {
  if (!mapInstance || !mapInstance._container || !bounds) return;

  requestAnimationFrame(() => {
    if (mapInstance && mapInstance._container && mapInstance._loaded) {
      try {
        mapInstance.fitBounds(bounds, {
          padding: [50, 50],
          animate: false,
          maxZoom: 16
        });
      } catch (err) {
        console.error('Error fitting bounds:', err);
      }
    }
  });
};